/**
 * Site do Kompil (a landing). A página de download fica lá: o app não tem mais a própria página
 * /download (o endereço antigo redireciona para cá). Configure VITE_LANDING_URL no build da web.
 */
export const LANDING_URL = (
  (import.meta.env.VITE_LANDING_URL as string | undefined) || "https://www.kompilcode.com"
).replace(/\/+$/, "");

/** Página "Baixar o Kompil" da landing (instaladores, requisitos e hash de cada sistema). */
export const DOWNLOAD_URL = `${LANDING_URL}/baixar`;
